import instance from "api/instance";

const getTransactionLogs = async (params) => {
  const response = await instance.get("/admin/transaction-logs/list", { params });
  if (response.status === 200) {
    return response.data;
  }
  return Promise.reject(response.data);
};

const getTransactionLogDetails = async (logId) => {
  const response = await instance.get(`/admin/transaction-logs/${logId}`);
  if (response.status === 200) {
    return response.data;
  }
  return Promise.reject(response.data);
};

const transactionLogsService = {
  getTransactionLogs,
  getTransactionLogDetails,
};

export default transactionLogsService;